module.exports = __webpack_public_path__ + "static/8-5cb371a614e6f681e020abc8dffbfced.svg";